import type { ThemeAndColorsBranding } from "@freyr/freyr-react-common-components";

export type {
  BrandIdentity,
  BrandingLinkSetting,
  CachedTenantBranding,
  LoginScreenBranding,
  TenantBranding,
  ThemeAndColorsBranding
} from "@freyr/freyr-react-common-components";

/** Freya Fusion default palette; aligns with designsystem-brand-overrides.scss fallbacks. */
export const DEFAULT_THEME_AND_COLORS: ThemeAndColorsBranding = {
  primaryColor: "#295ef1",
  primaryFontColor: "#ffffff",
  secondaryFontColor: "#f2f2f2",
  headerBackgroundColor: "#0b1f53",
};
